import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p447397041292791808',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
